class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.body = this.querySelector('[data-cart-body]');
  }

  connectedCallback() {
    this.querySelectorAll('[data-cart-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );

    this.addEventListener('click', (e) => {
      const quickBuyBtn = e.target.closest('[data-quick-buy]');
      if (quickBuyBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.quickBuy(quickBuyBtn);
        return;
      }

      const upsellBtn = e.target.closest('[data-cart-upsell-add]');
      if (upsellBtn) {
        e.preventDefault();
        this.addUpsell(upsellBtn);
        return;
      }

      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        const item = removeBtn.closest('[data-cart-item]');
        if (item) this.changeItem(item.dataset.key, 0);
      }

      const qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        const item = qtyBtn.closest('[data-cart-item]');
        const delta = parseInt(qtyBtn.dataset.qtyChange, 10);
        const current = parseInt(item.querySelector('[data-qty]').textContent, 10) || 0;
        this.changeItem(item.dataset.key, Math.max(0, current + delta));
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });
  }

  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  async changeItem(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!response.ok) throw new Error('change failed');
      await this.refresh();
    } catch (err) {
      console.error('[cart-drawer]', err);
    }
  }

  async quickBuy(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    const label = button.textContent;
    button.disabled = true;
    button.textContent = '...';

    try {
      const item = { id: parseInt(variantId, 10), quantity: 1 };
      const preorderSource = button.closest('[data-preorder-property-name]');
      if (preorderSource?.dataset.preorderPropertyName && preorderSource?.dataset.preorderPropertyValue) {
        item.properties = {
          [preorderSource.dataset.preorderPropertyName]: preorderSource.dataset.preorderPropertyValue,
        };
      }
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });
      if (!response.ok) throw new Error('quick-buy failed');
      await this.refresh();
      this.open();
    } catch (err) {
      console.error('[quick-buy]', err);
      button.disabled = false;
      button.textContent = label;
    }
  }

  async addUpsell(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = '...';

    try {
      const payload = { id: parseInt(variantId, 10), quantity: 1 };
      const preorderSource = button.closest('[data-preorder-property-name]');
      if (preorderSource?.dataset.preorderPropertyName && preorderSource?.dataset.preorderPropertyValue) {
        payload.properties = {
          [preorderSource.dataset.preorderPropertyName]: preorderSource.dataset.preorderPropertyValue,
        };
      }
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error('upsell add failed');
      await this.refresh();
      document.querySelector('cart-drawer')?.open();
    } catch (err) {
      console.error('[cart-upsell]', err);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = label;
    }
  }

  async refresh() {
    await fetch(window.location.pathname + '?sections=cart-drawer-refresh', {
      headers: { Accept: 'application/json' },
    }).catch(() => null);

    const html = await fetch('/?cart-drawer=1').then((response) => response.text()).catch(() => null);
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('cart-drawer');
      if (next) this.replaceWith(next);
    }

    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';
        const badge = el.closest('.pompeii-header__cart-badge');
        if (badge) badge.style.display = cart.item_count > 0 ? '' : 'none';
      });
    } catch {}
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-cart-toggle], a[href="/cart"], a[href$="/cart"]');
  if (!opener) return;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  e.preventDefault();
  drawer.open();
});

document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  e.preventDefault();
  const data = new FormData(form);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data,
    });
    if (!response.ok) throw new Error('add failed');

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      await drawer.refresh();
      document.querySelector('cart-drawer')?.open();
    }
  } catch (err) {
    console.error('[cart-add]', err);
    form.submit();
  }
});
